if (!customElements.get('marquee-bar')) {
  customElements.define(
    'marquee-bar',
    class MarqueeBar extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector('.marquee__inner');
        this.group = this.querySelector('.marquee__group');
        if (!this.inner || !this.group) return;

        this.lastWidth = 0;
        this.build();

        // Fonts load after first paint and change the track width, so measure again.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.build());
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.build());
          this.resizeObserver.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      build() {
        const containerWidth = this.offsetWidth;
        if (!containerWidth) return;

        // Cloning does not change our own width, but guard against redundant work.
        const groupWidth = this.group.offsetWidth;
        if (!groupWidth) return;
        if (containerWidth === this.lastWidth && this.classList.contains('marquee--ready')) return;
        this.lastWidth = containerWidth;

        this.inner.querySelectorAll('.marquee__group--clone').forEach((node) => node.remove());

        // Enough copies to cover twice the visible width, so the loop never shows a gap.
        const copies = Math.max(2, Math.ceil((containerWidth * 2) / groupWidth));
        const fragment = document.createDocumentFragment();

        for (let i = 1; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.classList.add('marquee__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          // Clones are decorative: keep them out of the editor and the tab order.
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
            node.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
        }

        this.inner.appendChild(fragment);

        // Speed is px/second, so the pace stays the same however many messages there are.
        const speed = parseFloat(this.dataset.speed) || 60;
        this.style.setProperty('--marquee-shift', `${groupWidth}px`);
        this.style.setProperty('--marquee-duration', `${groupWidth / speed}s`);
        this.classList.add('marquee--ready');
      }
    }
  );
}
